import { useEffect } from "react";

import useAZZKUYears from "hooks/AZZKU/useAZZKUYears";
import Options from "components/Options";

export default function AZZKUTopResultsYear({ params, onChange }) {

   const { d: years } = useAZZKUYears({
      variable_id: params.variable_id
   });

   useEffect(() => {
      if ( !years ) return;

      let year = params.year;

      if ( year )
         year = !!years.find( y => +y.value === +year ) ? year: years[0]?.value; 
      
      onChange({ year })
   }, [ years ])

   return (
      <Options
         name="year"
         extra_classes="mini"
         value={ +params.year }
         options={ years || []}
         onChange={ onChange }
      />
   )
}